/**
 * Horizontal Phase Chart Component
 *
 * Displays budget phases as horizontal bars for visual comparison
 * Right column chart showing phase execution values
 */

import { PhaseChartData } from "@/types/orcamentos.interface";

interface HorizontalPhaseChartProps {
  /** Chart data with phase names and values */
  data: PhaseChartData[];
}

export function HorizontalPhaseChart({ data }: HorizontalPhaseChartProps) {
  // Find max value for scaling
  const maxValue = Math.max(...data.map((d) => d.value), 1);

  // Format number for display
  const formatNumber = (value: number) => {
    if (value >= 1000000) {
      return `${(value / 1000000).toFixed(1)}M`;
    }
    if (value >= 1000) {
      return `${(value / 1000).toFixed(0)}K`;
    }
    return value.toString();
  };

  return (
    <div className="bg-[#15203C] rounded-[20px] p-[30px]">
      <div className="flex flex-col gap-[20px]">
        {/* Title */}
        <h3 className="text-[16px] font-semibold text-[#F6F6F6]">
          Visão Geral dos Projetos
        </h3>

        {/* Chart area */}
        <div className="flex flex-col gap-[12px]">
          {/* Y-axis labels and bars */}
          <div className="flex flex-col gap-[12px]">
            {data.map((item, index) => {
              const percentage = (item.value / maxValue) * 100;

              return (
                <div key={index} className="flex items-center gap-[12px]">
                  {/* Phase name label - fixed width */}
                  <div className="w-[150px] flex-shrink-0">
                    <p className="text-[12px] font-normal text-[#E7E7E7] truncate">
                      {item.name}
                    </p>
                  </div>

                  {/* Bar */}
                  <div className="flex-1 h-[25px] bg-transparent rounded-[10px] overflow-hidden">
                    <div
                      className="h-full bg-[#7846FF] rounded-[10px] transition-all duration-300"
                      style={{ width: `${percentage}%` }}
                    />
                  </div>

                  {/* Value label */}
                  <div className="w-[80px] text-right flex-shrink-0">
                    <p className="text-[12px] font-semibold text-white">
                      {formatNumber(item.value)}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
